import * as Analytics from 'analytics/Analytics';
import {ActionMethod, ActionOrigin, ELN_ANALYTICS_ACTIONS} from 'constants/AnalyticsConstants';
import {ShortcutDescription} from 'util/Keyboard';

export interface KeyboardFormatTrackingArgs {
  actionOrigin: ActionOrigin;
  actionMethod: ActionMethod;
  wasTextSelected?: boolean;
  eventGroupId?: string;
}

/**
 * Track a keyboard shortcut usage for analytics.
 *
 * @param description The shortcut description (including normalized shortcut text + string description)
 * @param keyboardFormatTrackingArgs Args for tracking a hotkey for use with formatting
 */
export function trackKeyboardShortcut(
  description: ShortcutDescription,
  keyboardFormatTrackingArgs?: KeyboardFormatTrackingArgs
): void {
  Analytics.trackEvent(ELN_ANALYTICS_ACTIONS.USED_KEYBOARD_SHORTCUT, {
    shortcut: description.shortcut.normalizedShortcutText,
    description: description.description,
    ...keyboardFormatTrackingArgs,
  });
}

export const SAVED_CMD_K_LINK_MODAL_DESCRIPTION = 'Saved link modal after hitting cmd/ctrl-k!';

/**
 * Intended to track whether the user saved the link modal, specifically *after* opening
 * it with Cmd + K keyboard shortcut (doesn't include manual link opens). Also doesn't include
 * SET_LINK action of pasting a link onto text.
 *
 * @param description The shortcut description (including normalized shortcut text + string description)
 * @param keyboardFormatTrackingArgs Args for tracking a hotkey for use with formatting
 */
export function trackSavedCmdKLinkModal(keyboardFormatTrackingArgs?: KeyboardFormatTrackingArgs): void {
  Analytics.trackEvent(ELN_ANALYTICS_ACTIONS.SAVED_CMD_K_LINK_MODAL, {
    description: SAVED_CMD_K_LINK_MODAL_DESCRIPTION,
    ...keyboardFormatTrackingArgs,
  });
}
